var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper",style:({ backgroundColor: _vm.bgColor, color: _vm.color })},[_c('div',{staticClass:"text",domProps:{"textContent":_vm._s(_vm.msg)}},[_vm._v("This is a horizontally scrolling text without a marquee tag.")])])}
var staticRenderFns = []

export { render, staticRenderFns }